import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
const baseurl ='dendabungakredit';
export default {
    dendabungaharian(obj){
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['pinjamankey'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}${str}`
                const {data} = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    printdendapdf(obj){
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['pinjamankey'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/printdendapdf${str}`;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    printbungapdf(obj){
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['pinjamankey'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/printbungapdf${str}`;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    }
}